var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"topic-reference"},[_c('div',{ref:"wheel",staticClass:"topic-reference_wheel topic-wheel"})])}
var staticRenderFns = []

export { render, staticRenderFns }